export const GET_PARTNERS_BY_ROOT_PATH = '/graphql/execute.json/yme/getPartnersByRootPath;path=';
export var CardsPerPage;
(function (CardsPerPage) {
    CardsPerPage[CardsPerPage["DESKTOP"] = 15] = "DESKTOP";
    CardsPerPage[CardsPerPage["MOBILE"] = 8] = "MOBILE";
})(CardsPerPage || (CardsPerPage = {}));
